<template>
  <div />
</template>

<script>
import * as echarts from "echarts";
import "echarts/extension/bmap/bmap";
const img1 =
  "image://data:image/png;base64,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";
export default {
  props: {
    dataList: {
      type: Array,
    },
    CoordMap: {
      type: Object,
    },
  },
  data() {
    //防抖
    const debounce = (fn) => {
      let timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn();
        }, 200);
      };
    };

    return {
      chart: null,
      cancalDebounce: debounce(this.windowResize),
      // geoCoordMap: this.CoordMap? this.CoordMap:{}
      // {
      //   珠海大音智源: [113.546714, 22.283694],
      //   珠海大音智源1: [113.546714, 22.293694],
      //   珠海大音智源2: [113.536714, 22.283694],
      //   惠州观音山: [114.935486, 22.688432],
      //   惠州观音山1: [114.935486, 22.698432],
      //   惠州观音山2: [114.935486, 22.678432],
      //   惠州观音山3: [114.945486, 22.688432],
      // }

      // ,
      // data:this.$store.state.localtionList?this.$store.state.localtionList:[],
      // data: [
      //   // { name: "珠海大音智源", value: (113.546714, 22.283694), status: 1 },
      //   // { name: "珠海大音智源1", value: [113.546714, 22.293694], status: 0 },
      //   // { name: "珠海大音智源2", value:   [113.536714, 22.283694], status: -1 },
      //   // { name: "惠州观音山", value:  [114.935486, 22.688432], status: 1 },
      //   // { name: "惠州观音山1", value: [114.935486, 22.698432], status: 0 },
      //   // { name: "惠州观音山2", value:  [114.935486, 22.678432], status:-1 },
      //   { name: "惠州观音山3", value:  "114.945486, 22.688432", status: 1 },
      // ],
    };
  },
  mounted() {
    this.initChart();
    // window.addEventListener("resize", this.cancalDebounce);

    var bmap = this.chart.getModel().getComponent("bmap").getBMap();
    // bmap.addControl(new BMap.MapTypeControl());
    bmap.setMapType(BMAP_SATELLITE_MAP);
    // var  p2= document.getElementsByClassName(' anchorBL');
    // console.log(p2);
    // p2.parentNode.removeChild(p2);
    setTimeout(() => {
      var mydiv = document.getElementsByClassName(" anchorBL")[0]; //获得要删除的节点
      var parent = document.getElementsByClassName("ec-extension-bmap")[0]; //获得要删除的节点的父节点
      var mydiv2 = document.getElementsByClassName(" anchorBL")[1]; //获得要删除的节点
      // var parent2 = document.getElementsByClassName("ec-extension-bmap")[1]; //获得要删除的节点的父节点
      // parent.removeChild(mydiv); //通过父节点来删除子节点
      // parent.removeChild(mydiv2); //通过父节点来删除子节点
    }, 100);
  },
  methods: {
    windowResize() {
      //销毁图表重新画;
      setTimeout(() => {
        this.chart.dispose();
        this.initChart();
      }, 100);
    },
    convertData(data) {
      let res = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (this.dataList) {
            if (data[i].status == -1) {
              res.push({
                name: data[i].name,
                value: data[i].value.split(","),
                windId: data[i].windId,
                // img: "image://" + require("../assets/导出切图/status-G.png"),
                img1: "image://",
                // img2: "image://" + require("../assets/导出切图/circle-g.png"),
              });
            }
            if (data[i].status == 1) {
              res.push({
                name: data[i].name,
                value: data[i].value.split(","),
                windId: data[i].windId,
                // img: "image://" + require("../assets/导出切图/status-N.png"),
                // img1: "image://" + require("../assets/导出切图/warn-g.png"),
                // img2: "image://" + require("../assets/导出切图/circle-n.png"),
              });
            }
            if (data[i].status == 2) {
              res.push({
                name: data[i].name,
                value: data[i].value.split(","),
                windId: data[i].windId,
                // img: "image://" + require("../assets/导出切图/status-R.png"),
                // img1: "image://" + require("../assets/导出切图/warn-r.png"),
                // img2: "image://" + require("../assets/导出切图/circle-r.png"),
              });
            }
            if (data[i].status == 3) {
              res.push({
                name: data[i].name,
                value: data[i].value.split(","),
                windId: data[i].windId,
                // img: "image://" + require("../assets/导出切图/status-Y.png"),
                // img1: "image://" + require("../assets/导出切图/warn-y.png"),
                // img2: "image://" + require("../assets/导出切图/circle-y.png"),
              });
            }
          }
        }
      }

      return res;
    },
    initChart() {
      this.chart = echarts.init(this.$el);
      this.chart.on("click", (params) => {
        console.log(params);
        this.$store.state.curWindName = params.data.name;
        this.$store.state.curWindId = params.data.windId;
        // if (params.data.name == "珠海大音智源") {
        // this.$store.state.isShowMap = false;
        this.$router.push("/detail");
        // }
      });

      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "item",
        },
        bmap: {
          center: this.$store.state.localtionData,
          zoom: this.$store.state.mapzoom,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                featureType: "water",
                elementType: "all",
                stylers: {
                  color: "#031628",
                },
              },
              {
                featureType: "land",
                elementType: "geometry",
                stylers: {
                  color: "#000102",
                },
              },
              {
                featureType: "highway",
                elementType: "all",
                stylers: {
                  visibility: "off",
                },
              },
              {
                featureType: "arterial",
                elementType: "geometry.fill",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "arterial",
                elementType: "geometry.stroke",
                stylers: {
                  color: "#0b3d51",
                },
              },
              {
                featureType: "local",
                elementType: "geometry",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "railway",
                elementType: "geometry.fill",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "railway",
                elementType: "geometry.stroke",
                stylers: {
                  color: "#08304b",
                },
              },
              {
                featureType: "subway",
                elementType: "geometry",
                stylers: {
                  lightness: -70,
                },
              },
              {
                featureType: "building",
                elementType: "geometry.fill",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "all",
                elementType: "labels.text.fill",
                stylers: {
                  color: "#857f7f",
                },
              },
              {
                featureType: "all",
                elementType: "labels.text.stroke",
                stylers: {
                  color: "#000000",
                },
              },
              {
                featureType: "building",
                elementType: "geometry",
                stylers: {
                  color: "#022338",
                },
              },
              {
                featureType: "green",
                elementType: "geometry",
                stylers: {
                  color: "#062032",
                },
              },
              {
                featureType: "boundary",
                elementType: "all",
                stylers: {
                  color: "#465b6c",
                },
              },
              {
                featureType: "manmade",
                elementType: "all",
                stylers: {
                  color: "#022338",
                },
              },
              {
                featureType: "label",
                elementType: "all",
                stylers: {
                  // visibility: 'off'
                },
              },
            ],
          },
        },
        series: [
        
          //风机图
          {
            tooltip: {
              show: false,
            },
            // type: 'effectScatter',
            type: "scatter",
            coordinateSystem: "bmap",
            rippleEffect: {
              scale: 10,
              brushType: "stroke",
            },
            showEffectOn: "render",

            label: {
              normal: {
                color: "#fff",
              },
            },
            symbol: img1,
            symbolSize: [50, 150],
            symbolOffset: [10, -75],
            data: this.convertData(this.dataList),
            zlevel: 1,
          },
          //风机柱状图
          {
            // type: 'effectScatter',

            type: "scatter",
            coordinateSystem: "bmap",
            data: this.convertData(this.dataList),
            // symbolSize: 120,
            symbolSize: [50, 150],
            symbolOffset: [0, -55],
            // symbol: 'image://' + require('../assets/background.jpg'),
            symbol: function (value, params) {
              return params.data.img;
            },
            encode: {
              value: 2,
            },
            showEffectOn: "render",
            rippleEffect: {
              period: "4", //动画的时间
              scale: 1,
              brushType: "stroke",
            },
            label: {
              normal: {
                position: "bottom",
                show: true,
                textStyle: {
                  color: "#FFFFFF",
                  fontSize: 16,
                  opacity: 1,
                },
                // series数据label前添加定制图标
                formatter: function (param) {
                  var res = "{xing|} " + param.name;
                  return res;
                },
                rich: {
                  xing: {
                    height: 16,
                    width: 16,
                    align: "left",
                    backgroundColor: {
                      // image: require("../assets/home01_slices/风机小图标.png"),
                    },
                  },
                },
              },
              // emphasis: {
              //     show: true,
              //     textStyle: {
              //         color: '#fff',
              //     },
              // },
            },
            //       label: {
            //         // formatter: "{b}",
            //         formatter: function(params) {

            // },
            //         position: "bottom",
            //         show: true,
            //       },
            // 标记点样式
            itemStyle: {
              // shadowBlur: 10,
              // shadowColor: "#333",
              // color: "#df2121",
              normal: {
                // // 线条颜色、宽度，节点大小、颜色等
                // color: "red", // 线条颜色
                // width: 3, // 线条宽度
                // borderColor: "red", // 节点边框颜色
                // borderWidth: 2, // 节点边框宽度
                // opacity: 1, // 节点透明度
                // label: {
                //   // 节点标签样式
                //   show: true,
                //   position: "top",
                //   textStyle: {
                //     color: "red",
                //   },
                // },
                // emphasis: {
                //   // 鼠标悬浮节点样式
                //   borderColor: "#4F81BD",
                //   borderWidth: 3,
                //   opacity: 1,
                // },
              },
            },
            emphasis: {
              scale: true,
            },
            zlevel: 1,
          },
          //扩散框
          {
            tooltip: {
              show: false,
            },
            type: "effectScatter",
            // type: "scatter",
            coordinateSystem: "bmap",
            rippleEffect: {
              period: "3", //动画的时间
              scale: 1.5,
              brushType: "stroke",
            },
            showEffectOn: "render",

            label: {
              normal: {
                color: "#fff",
              },
            },
            symbol: function (value, params) {
              return params.data.img1;
            },
            symbolSize: 50,
            symbolOffset: [3, -108],
            data: this.convertData(this.dataList),
            zlevel: 1,
          },
          //中间实心
          {
            tooltip: {
              show: false,
            },
            // type: 'effectScatter',
            type: "scatter",
            coordinateSystem: "bmap",
            rippleEffect: {
              period: "3", //动画的时间
              scale: 1.5,
              brushType: "stroke",
            },
            showEffectOn: "render",

            label: {
              normal: {
                color: "#fff",
              },
            },
            symbol: function (value, params) {
              return params.data.img2;
            },
            symbolSize: 30,
            symbolOffset: [3, -108],
            data: this.convertData(this.dataList),
            zlevel: 1,
          },
        ],
      });
    },
  },
  watch: {
    "$store.state.localtionData": {
      deep: true,
      handler: function () {
        this.setOptions();
      },
    },
    dataList: {
      deep: true,
      handler: function () {
        this.setOptions();
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/baiduMap.vue